module.exports = "<asui-horizontal-navbar options=\"$ctrl.options\" ng-model=\"$ctrl.navigationService.selected\" items=\"$ctrl.navigationService.items\"></asui-horizontal-navbar>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/shared/components/horizontalNavigationBar/horizontalNavigationBar.component.html
// module id = 722
// module chunks = 0